
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[lang]/[id]",
      function () {
        return require("private-next-pages/product/[lang]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[lang]/[id]"])
      });
    }
  